<div
    class="w-100 h-100 cursor--pointer"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
></div>       

<ng-template #content >
    <div class="popover-links popover-links--option-action mt-1">
        <div class="popover__action d-flex align-items-center cursor--pointer" (click)="onClick()">
            <span [ngClass]="textClasses" class="body-2 cursor--pointer">{{ text }}</span>
        </div>
    </div>
</ng-template>